import React from 'react';
import { Helmet } from 'react-helmet';

function Header() {
  return (
    <div>
      <Helmet>
        <title>Wyniki PZM – Wyniki Online Polskiego Związku Motorowego</title>
      </Helmet>
      {/* Rest of your component */}
    </div>
  );
}

export default Header;
